<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .icons {
    display: flex;
    flex-direction: row;
    gap: utils.in_rem(4px);
  }

  .text {
    @include colors.color(textLighterBlack);
    @include mixins.body2();
    max-width: utils.in_rem(200px);
    text-align: center;
  }
</style>

<script>
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";

  import Badge from "@sourcewhale/shared/svelte-design-system/components/atoms/Badge.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";
  import NoContactInfoButtons from "./NoContactInfoButtons.svelte";
</script>

<NoData class="flex-1">
  <div slot="icons" class="icons">
    <Badge value={$userStore?.emailCredits || 0} position="center">
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-envelope-open"
        size="xl"
      />
    </Badge>
    <Badge value={$userStore?.phoneCredits || 0} position="center">
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-phone"
        size="xl"
      />
    </Badge>
  </div>
  <div slot="text" class="text">You have no contact information yet.</div>
  <NoContactInfoButtons slot="buttons" />
</NoData>
